import { PATHS_WITH_SEARCH } from "constants/pathnames";
import { matchPath, useLocation } from "react-router-dom";

export const usePathPattern = () => {
  const { pathname } = useLocation();
  if (!PATHS_WITH_SEARCH || !Array.isArray(PATHS_WITH_SEARCH)) {
    return null;
  }
  return PATHS_WITH_SEARCH.find((route) => matchPath(route, pathname)) || null;
};
